import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAppSelector } from '../hooks/reduxHooks';
import Login from '../components/Login';
import App from '../App';
import FeedbackForm from '../pages/Feedback/FeedbackForm';
import PublicFeedbackForm from '../pages/Feedback/PublicFeedbackForm';

// Protected route wrapper
const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useAppSelector(state => state.auth);
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return <>{children}</>;
};

/** Old single-segment URLs no longer work — GRC is scoped per property. */
const PublicFeedbackLegacyHint: React.FC = () => (
  <div style={{ padding: 48, textAlign: 'center', fontFamily: 'system-ui, sans-serif', maxWidth: 560, margin: '0 auto' }}>
    <h1 style={{ fontSize: '1.25rem' }}>Updated feedback link</h1>
    <p style={{ color: '#444', lineHeight: 1.6 }}>
      Feedback URLs now include your property code and GRC number:
      <br />
      <code style={{ fontSize: '0.95rem' }}>/public-feedback/&lt;property&gt;/&lt;GRC&gt;</code>
    </p>
    <p style={{ color: '#444' }}>
      Example: <code>/public-feedback/TB/GRC12345</code>
    </p>
    <p style={{ color: '#666', fontSize: '0.9rem' }}>Use the link from your checkout email or WhatsApp message.</p>
  </div>
);

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        
        {/* Public routes that don't require authentication */}
        <Route path="/feedback/:token" element={<FeedbackForm />} />
        <Route path="/public-feedback/:propertyId/:grcNo" element={<PublicFeedbackForm />} />
        <Route path="/public-feedback/:legacyGrcOnly" element={<PublicFeedbackLegacyHint />} />
        
        <Route 
          path="/*" 
          element={
            <ProtectedRoute>
              <App />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes; 